// @flow
// @deprecated

import React, { useState, useEffect, useMemo, useRef, SyntheticEvent } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import queryString from 'query-string';
import BasicHeader from './BasicHeader';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripeElementWrapper from './StripeElementWrapper';
import { useSelector, useDispatch } from 'react-redux';
import { log } from '../../utils/jsUtils';
import SPBackend from '../../services/SPBackend';
import classNames from 'classnames';
import { setBilling } from '../../reduxStore/modules/billing/actions';
import { selectBillingState } from '../../reduxStore/modules/billing/selectors';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Logo from '../../assets/askneo-favicon.png';
import { useUserAuth } from '../Auth/UserSession';

// The old styles
import { createClasses } from '../../utils/stylesUtils';
import signupStyles from '../PublicCpts/Styles/Signup.Style';
import styles from './Styles/CheckoutHome.Style';

// Build the classes from classes:
import { useTheme } from '@mui/material/styles';

// Add selectors
// User selectors
const selectUserState = (state) => state.user || {};
const selectUser = (state) => selectUserState(state).user;
const selectUserFullName = (state) => selectUserState(state).fullName;
const selectDefaultBuilding = (state) => selectUserState(state).defaultBuilding;


// Old code: `const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);`
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

// Subcomponent "ckForm," now receives no "classes" prop but builds them itself:
function CkForm(props: {
  planinfo: Object,
  coupon: ?Object,
}) {
  const {
    planinfo,
    coupon
  } = props;

  // Use the useStripe and useElements hooks provided by @stripe/react-stripe-js
  const stripe = useStripe();
  const elements = useElements();

  const history = useHistory();
  const dispatch = useDispatch();
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [cardholderName, setCardholderName] = useState('');
  const [chargeError, setChargeError] = useState('');
  
  // Use separate selectors for each piece of state to avoid reference issues
  const user = useSelector(state => state.user?.user);
  const billing = useSelector(selectBillingState);
  const defaultBuilding = useSelector(state => state.user?.defaultBuilding);
  const { planId } = billing;

  // Use a ref to track if we've already set planId in redux
  const didSetPlanId = useRef(false);

  const theme = useTheme();
  const classes = createClasses({
    ...styles,
    ...signupStyles
  }, theme);

  // Effect to ensure planId is set in Redux from planinfo only once
  useEffect(() => {
    if (!didSetPlanId.current && planinfo && planinfo.id) {
      // Only dispatch if the planId in billing doesn't match planinfo.id
      if (billing.planId !== planinfo.id) {
        dispatch({
          type: 'ACTION_SET_BILLING_PLANID',
          planId: planinfo.id
        });
        log('[CkForm] Updated planId in Redux on mount:', planinfo.id);
      }
      didSetPlanId.current = true;
    }
  }, [dispatch, planinfo, billing.planId]);
  
  const handleSubmit = async (ev: SyntheticEvent<HTMLFormElement>) => {
    try {
      ev.preventDefault();
      setPaymentLoading(true);
      
      // First check if stripe and elements are loaded
      if (!stripe || !elements) {
        setChargeError('Stripe is still loading. Please try again in a moment.');
        setPaymentLoading(false);
        return;
      }

      log('submit payment!', ev);
      log('elements: ', elements);
      const cardElement = elements.getElement(CardElement);
      
      if (!cardElement) {
        setChargeError('Card information not found. Please refresh and try again.');
        setPaymentLoading(false);
        return;
      }

      log('[handleSubmit] elements(cardNumber): ', cardElement);
      log('[handleSubmit] planId from billing:', planId);
      log('[handleSubmit] planinfo.id:', planinfo.id);

      const pmResult = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: cardholderName
        }
      });
      const { paymentMethod, error: pmError } = pmResult;
      if (pmError) {
        log('Stripe paymentMethod error: ', pmError);
        if (pmError.code === 'parameter_invalid_empty') {
          throw Error('All fields are required.');
        }
        throw Error(pmError.message);
      }
      
      // Use the planinfo.id if planId from Redux is missing
      const effectivePlanId = planId || planinfo.id;
      if (!effectivePlanId) {
        setChargeError('Please choose a plan first.');
        throw Error('Please choose a plan first.');
      }
      
      log('resulting pmResult: ', paymentMethod);
      log('[handleSubmit] Using plan ID:', effectivePlanId);

      // build trial end period
      const trialObj = {};
      if (planinfo.trial_period_days && planinfo.trial_period_days > 0) {
        trialObj.trialEnd = moment().add(planinfo.trial_period_days, 'days').unix();
      }

      const paymentPayload = {
        paymentMethod,
        planId: effectivePlanId,
        ...trialObj
      };
      if (typeof coupon !== 'undefined' && coupon !== null) {
        paymentPayload.coupon = coupon.id;
      }
      SPBackend.chargePlan(paymentPayload, user)
        .then((response) => {
          setChargeError('');
          log('charge response: ', response);
          SPBackend.getAccount(user)
            .then((resp) => {
              log('[getAccount] response: ', resp);
              const { data } = resp;
              const { user: newUser, account, billing: newBilling } = data;
              
              // Update Redux billing state
              dispatch(setBilling(newBilling));
              
              if (
                defaultBuilding
                && (
                  typeof defaultBuilding.Phone === 'undefined'
                  || defaultBuilding.Phone === null
                  || defaultBuilding.Phone === ''
                )
              ) {
                log('redirecting to phone number picker');
                history.push('/pickYourPhoneNumber');
              } else {
                log('redirecting to member');
                history.push('/member');
              }
              setPaymentLoading(false);
            })
            .catch((err) => {
              log('[handleSubmit] getAccount error: ', err);
              setPaymentLoading(false);
            });
        })
        .catch((error) => {
          log('[handleSubmit] charge error.response: ', error.response);
          setPaymentLoading(false);
          const data = error.response?.data || 'Payment failed. Please try again.';
          setChargeError(data);
        });
    } catch (e) {
      log('[handleSubmit] e.name: ', e.name);
      if (e.name === 'IntegrationError') {
        setChargeError('Missing card information');
      } else {
        log('[handleSubmit] error caught: ', e.name, e);
        setChargeError(e.message);
      }
      setPaymentLoading(false);
    }
  };

  log('planinfo: ', planinfo);

  return (
    <form onSubmit={handleSubmit}>
      <Helmet>
        <title>Neo | Checkout</title>
      </Helmet>
      <Grid container>
        <Grid item xs={12}>
          <Typography sx={classes.formLabel} variant="body1">
            {'Cardholder full name'}
          </Typography>
          <FormControl
            sx={classes.newInputForm}
            variant="outlined"
          >
            <OutlinedInput
              sx={(theme) => ({
                ...classes.newFormElt,
                ...classes.checkoutInputForm
              })}
              id="companyName"
              margin="dense"
              name="companyName"
              onChange={(event) => setCardholderName(event.target.value)}
              placeholder="Cardholder full name"
              type="text"
              value={cardholderName}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={classes.formLabel} variant="body1">
            {'Card information'}
          </Typography>
          <StripeElementWrapper component={CardElement} id="card-elt-id" label="" />
        </Grid>
        {planinfo.trial_period_days > 0 ? (
          <Grid item xs={12}>
            <Typography sx={classes.infoLabel} variant="body1">
              {`Your ${planinfo.trial_period_days}-day free trial lasts until ${moment()
                .add(planinfo.trial_period_days, 'days')
                .format('MMMM D, YYYY [at] hA')}. If you don't want to continue using askneo.io, just cancel before the trial ends and you won't be charged.`}
            </Typography>
            <Typography variant="body1">
              <b>{'Questions? Text us: (917) 451-5515'}</b>
            </Typography>
          </Grid>
        ) : null}

        {chargeError !== '' ? (
          <Grid sx={classes.errorLabel} item xs={12}>
            {chargeError}
          </Grid>
        ) : null}

        <Button
          color="primary"
          disabled={planinfo.product === '' || paymentLoading}
          style={{ marginTop: 16 }}
          type="submit"
          variant="contained"
        >
          {planinfo ? 'Subscribe' : 'Loading'}
        </Button>
      </Grid>
    </form>
  );
}

// Now the main "Checkout" component that uses <Elements>:
function Checkout(props: {}) {
  // We'll build classes here too for the container, etc.
  const theme = useTheme();
  const classes = createClasses({
    ...styles,
    ...signupStyles
  }, theme);
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();

  const [planInfo, setPlanInfo] = useState({
    nickname: '',
    active: true,
    amount: 0,
    currency: 'usd',
    interval: 'month',
    interval_count: 0,
    product: ''
  });
  const [coupon, setCoupon] = useState('');
  const [couponId, setCouponId] = useState('');
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [productInfo, setProductInfo] = useState({
    name: ''
  });
  const [showCoupon, setShowCoupon] = useState(false);
  const [isCouponLoading, setIsCouponLoading] = useState('false');
  
  // Use separate selectors for each piece of state to avoid reference issues
  const user = useSelector(state => state.user?.user);
  const billing = useSelector(selectBillingState);
  const defaultBuilding = useSelector(state => state.user?.defaultBuilding);
  const { planId } = billing;

  const parsed = queryString.parse(location.search);
  const { planid: paramPlanId } = parsed;

  // Define hasRequiredPlanData here before using it in useEffect
  const hasRequiredPlanData = planInfo.nickname && productInfo.name && planInfo.product;

  useEffect(() => {
    log('[Checkout] Initial render - parsed:', parsed);
    log('[Checkout] paramPlanId:', paramPlanId);
    log('[Checkout] user:', user);
    log('[Checkout] billing:', billing);
    
    if (paramPlanId && paramPlanId !== '') {
      // Only dispatch if the planId in billing doesn't match paramPlanId
      if (billing.planId !== paramPlanId) {
        log('[Checkout] Setting planId in Redux:', paramPlanId);
        // Update Redux instead of store
        dispatch({
          type: 'ACTION_SET_BILLING_PLANID',
          planId: paramPlanId
        });
      }
      
      // Only fetch plan info if we don't already have it
      if (!hasRequiredPlanData && user) {
        log('[Checkout] Fetching plan info for:', paramPlanId);
        SPBackend.getPlanInfo(paramPlanId, user)
          .then((response) => {
            log('[Checkout] Plan info response:', response.data);
            const { plan, product } = response.data;
            
            // Log the exact values we're setting to state
            log('[Checkout] Setting planInfo:', plan);
            log('[Checkout] Setting productInfo:', product);
            
            // Ensure we're setting the exact properties needed for rendering
            setPlanInfo({
              ...plan,
              nickname: plan.nickname || '',  // Ensure nickname is never undefined
              product: plan.product || ''     // Ensure product is never undefined
            });
            
            setProductInfo({
              ...product,
              name: product.name || ''        // Ensure name is never undefined
            });
          })
          .catch((err) => {
            log('[Checkout] Error fetching plan info:', err);
            dispatch({
              type: 'ACTION_SET_SNACK_MSG',
              snackMessage: {
                message: err.message,
                level: 'error',
                duration: 5000
              }
            });
          });
      } else if (!user) {
        log('[Checkout] No user found, redirecting to plans');
        history.push('/plans');
      }
    } else {
      log('[Checkout] No planId in URL, redirecting to plans');
      history.push('/plans');
    }
  }, [paramPlanId, dispatch, user, history, hasRequiredPlanData, billing.planId]);

  log('[Checkout] Current state - planInfo:', planInfo);
  log('[Checkout] Current state - productInfo:', productInfo);
  log('[Checkout] Current state - hasRequiredPlanData:', hasRequiredPlanData);
  log('[Checkout] Current state - user:', user);

  const getCouponCode = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (user) {
      log('[getCouponCode] fetching couponId: ', couponId);
      SPBackend.getCouponInfo(couponId, user)
        .then((response) => {
          log('[getCouponCode] coupon response: ', response.data);
          const { success, message, coupon: fetchedCoupon } = response.data;
          if (success === 'error') {
            dispatch({
              type: 'ACTION_SET_SNACK_MSG',
              snackMessage: {
                message,
                level: 'error',
                duration: 5000
              }
            });
          }
          if (fetchedCoupon && !fetchedCoupon.valid) {
            dispatch({
              type: 'ACTION_SET_SNACK_MSG',
              snackMessage: {
                message: 'Invalid coupon',
                level: 'error',
                duration: 5000
              }
            });
          }
          setCoupon(fetchedCoupon);
        })
        .catch((err) => {
          log('[getCouponCode] err: ', err);
          dispatch({
            type: 'ACTION_SET_SNACK_MSG',
            snackMessage: {
              message: err.message,
              level: 'error',
              duration: 5000
            }
          });
        });
    }
  };

  const chargeFreePlan = () => {
    log('[chargeFreePlan] planId: ', planId);
    log('[chargeFreePlan] planInfo: ', planInfo);
    setPaymentLoading(true);
    const trialObj = {};
    if (planInfo.trial_period_days && planInfo.trial_period_days > 0) {
      trialObj.trialEnd = moment().add(planInfo.trial_period_days, 'days').unix();
    }
    const params = {
      paymentMethod: {},
      planId,
      ...trialObj
    };
    log('[chargeFreePlan] params: ', params);
    SPBackend.chargePlan(params, user)
      .then((response) => {
        log('[chargeFreePlan] charge response: ', response);
        SPBackend.getAccount(user)
          .then((resp) => {
            log('[chargeFreePlan][chargePlan] response: ', resp);
            const { data } = resp;
            const { user: newUser, account, billing: newBilling } = data;
            
            // Update Redux billing state
            dispatch(setBilling(newBilling));
            
            if (
              defaultBuilding
              && (
                typeof defaultBuilding.Phone === 'undefined'
                || defaultBuilding.Phone === null
                || defaultBuilding.Phone === ''
              )
            ) {
              log('redirecting to phone number picker');
              history.push('/pickYourPhoneNumber');
            } else {
              log('redirecting to member');
              history.push('/member');
            }
            setPaymentLoading(false);
          })
          .catch((err) => {
            log('[chargeFreePlan][chargePlan] getAccount error: ', err);
            setPaymentLoading(false);
          });
      })
      .catch((error) => {
        log('[chargeFreePlan][chargePlan] charge error: ', error);
        setPaymentLoading(false);
      });
  };

  return (
    <Grid container sx={classes.contentCtr}>
      <BasicHeader title="Checkout" />
      {console.log('[Checkout] Render - condition values:', {
        'planInfo exists': !!planInfo,
        'productInfo exists': !!productInfo,
        'productInfo.name': productInfo?.name,
        'planInfo.nickname': planInfo?.nickname,
        'hasRequiredPlanData': hasRequiredPlanData,
        'old condition': !!(planInfo && productInfo && productInfo.name !== '' && planInfo.nickname !== '')
      })}
      {hasRequiredPlanData ? (
        <Grid item xs={12}>
          <a href="/">
            <img height={40} src={Logo} alt="AskNeo Logo" />
          </a>
          <Typography variant="h3">{'Start your account'}</Typography>
          <Typography variant="body1">{'Step 3 of 3'}</Typography>

          <Paper sx={classes.formPaper}>
            <Box sx={classes.totalCtr}>
              <Box sx={classes.totalLeft}>
                <Typography sx={classes.totalLabel} variant="h3">
                  {'Subscription askneo.io'}
                </Typography>
                <Typography sx={classes.totalCaption} variant="body1">
                  {planInfo.amount > 0
                    ? `Billed ${
                        planInfo.interval === 'day' ? 'dai' : planInfo.interval
                      }ly`
                    : null}
                </Typography>
              </Box>
              <Box sx={classes.totalRight}>
                <Typography sx={classes.totalCost} variant="h3">
                  {coupon && coupon.valid ? (
                    <>
                      <Box component="span" sx={classes.striked}>{`$${planInfo.amount / 100}`}</Box>
                      <span>
                        {`$${(planInfo.amount - (planInfo.amount * coupon.percent_off) / 100) / 100}`}
                      </span>
                    </>
                  ) : planInfo.amount > 0 ? (
                    `$${planInfo.amount / 100}`
                  ) : (
                    'Free'
                  )}
                </Typography>
              </Box>
            </Box>

            {planInfo && planInfo.amount > 0 ? (
              <Box sx={classes.stripeCtr}>
                <Grid container sx={classes.totalCtr}>
                  <Grid item xs={12}>
                    <Typography variant="body1" style={{ marginBottom: 10 }}>
                      {'Enter your payment details:'}
                    </Typography>
                  </Grid>
                </Grid>

                {/*
                  ckForm subcomponent, using Stripe's Elements + plan info
                */}
                <Elements stripe={stripePromise}>
                  <CkForm planinfo={planInfo} coupon={coupon} />
                </Elements>
              </Box>
            ) : (
              <>
                <Typography variant="body1">
                  {'No payment needed. Your plan is free!'}
                </Typography>
                <Button
                  color="primary"
                  disabled={paymentLoading}
                  onClick={chargeFreePlan}
                  style={{ marginTop: 16 }}
                  variant="contained"
                >
                  {'Subscribe (Free)'}
                </Button>
              </>
            )}

            {/* Toggle a coupon input */}
            {!showCoupon ? (
              <Box sx={{ marginTop: 24 }}>
                <Button
                  color="primary"
                  startIcon={
                    !showCoupon ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />
                  }
                  onClick={() => setShowCoupon(!showCoupon)}
                  variant="text"
                >
                  {'Have a coupon code?'}
                </Button>
              </Box>
            ) : null}

            {showCoupon ? (
              <form onSubmit={(e) => {
                e.preventDefault();
                if (user) {
                  log('[getCouponCode] fetching couponId: ', couponId);
                  SPBackend.getCouponInfo(couponId, user)
                    .then((response) => {
                      log('[getCouponCode] coupon response: ', response.data);
                      const {
                        success, message, coupon: fetchedCoupon
                      } = response.data;
                      if (success === 'error') {
                        dispatch({
                          type: 'ACTION_SET_SNACK_MSG',
                          snackMessage: {
                            message,
                            level: 'error',
                            duration: 5000
                          }
                        });
                      }
                      if (fetchedCoupon && !fetchedCoupon.valid) {
                        dispatch({
                          type: 'ACTION_SET_SNACK_MSG',
                          snackMessage: {
                            message: 'Invalid coupon',
                            level: 'error',
                            duration: 5000
                          }
                        });
                      }
                      setCoupon(fetchedCoupon);
                    })
                    .catch((err) => {
                      log('[getCouponCode] err: ', err);
                      dispatch({
                        type: 'ACTION_SET_SNACK_MSG',
                        snackMessage: {
                          message: err.message,
                          level: 'error',
                          duration: 5000
                        }
                      });
                    });
                }
              }}>
                <input
                  onChange={(e) => setCouponId(e.target.value)}
                  placeholder="Enter coupon code"
                  style={{ fontSize: 16, marginTop: 12 }}
                  type="text"
                  value={couponId}
                />
                <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={{ marginLeft: 8 }}
                >
                  {'Apply coupon'}
                </Button>
              </form>
            ) : null}
          </Paper>
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Typography variant="h5">{'Loading plan...'}</Typography>
        </Grid>
      )}
    </Grid>
  );
}

// Finally, we export the main component:
export default Checkout;